@if (config()) {
  <div class="parameter-date-time-config">
    @if (!hideLabel()) {
      <div class="parameter-date-time-config__title">{{ parameterTitle() }}:</div>
    }
    <div class="parameter-date-time-config__wrapper">
      <mat-form-field
        class="parameter-date-time-config__field without-subscript small-form-field"
        appearance="outline"
      >
        <mat-label>Date</mat-label>
        <input
          matInput
          [matDatepicker]="picker"
          [ngModel]="date()"
          (dateChange)="onDateChange($event)"
        />
        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>

      <mat-form-field
        class="parameter-date-time-config__field without-subscript small-form-field"
        appearance="outline"
      >
        <mat-icon matSuffix>access_time</mat-icon>
        <mat-label>Hour</mat-label>
        <mat-select
          [ngModel]="hour()"
          [disabled]="disabled()"
          (selectionChange)="onChangeHour($event.value)"
          #hourSelect
        >
          @for (h of hours; track h) {
            <mat-option [value]="h">{{ h }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field
        class="parameter-date-time-config__field without-subscript small-form-field"
        appearance="outline"
      >
        <mat-icon matSuffix>access_time</mat-icon>
        <mat-label>Minute</mat-label>
        <mat-select
          [ngModel]="minute()"
          [disabled]="disabled()"
          (selectionChange)="onChangeMinute($event.value)"
          #minuteSelect
        >
          @for (m of minutes; track m) {
            <mat-option [value]="m">{{ m }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    @if (config().parameter.description && showInfo()) {
      <div class="small-icon-button-wrapper">
        <button mat-icon-button class="small-icon-button">
          <mat-icon color="primary" [matTooltip]="config().parameter.description"
            >info_outline
          </mat-icon>
        </button>
      </div>
    }
    @if (value() && !readonly() && hasDelete() && !disabled()) {
      <div class="small-icon-button-wrapper">
        <button mat-icon-button>
          <mat-icon
            (click)="onClickRemove()"
            class="parameter-date-time-config__close"
            color="warn"
            matTooltip="Discard changes"
            >close
          </mat-icon>
        </button>
      </div>
    }
    @if (value() !== undefined && !readonly() && hasUndo() && !disabled()) {
      <div class="small-icon-button-wrapper">
        <button mat-icon-button>
          <mat-icon
            (click)="onClickUndo()"
            class="parameter-date-time-config__close"
            color="warn"
            matTooltip="Discard changes"
            >close
          </mat-icon>
        </button>
      </div>
    }
    @if (hasClose() && !disabled()) {
      <div class="small-icon-button-wrapper">
        <button mat-icon-button>
          <mat-icon (click)="onClickClose()" matTooltip="Close">close</mat-icon>
        </button>
      </div>
    }
    @if (showReset() && !disabled()) {
      <div class="small-icon-button-wrapper">
        <button mat-icon-button (click)="onResetToFactory()" [matTooltip]="resetToFactoryTooltip()">
          <mat-icon color="warn">replay</mat-icon>
        </button>
      </div>
    }
  </div>
}
